$ = require 'jquery'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'

# Mixin for views that have the option to display an invitation link
module.exports = class DisplayInvitationLinkView extends View
  _secretUrl: ->
    "#{ @model.url() }/invitationSecret"

  showInvitationLink: (e) ->
    @$('.js-show-invitation-link').addClass('hide')
    @$('.js-invitation-link-container').removeClass('hide')

    ApiPromise
      method: 'post'
      url: @_secretUrl()
    .get 'secret'
    .then (secret) =>
      # Yes, this is gross … but eventually we won't be responsible for
      # forming these URLs anyway, since they should be coming from the server
      invitationUrl = @model.get('url').replace ///
        (
          /b/[^/]+ # the /b/:shortlink portion of a board URL
          |
          /[^/]+$ # the /:orgname portion of an org URL
        )
        (.*)$
      ///, "/invite$1/#{ secret }$2"

      @$('.js-invitation-link')
      .val(invitationUrl)
      .focus()
      .select()

    .done()

  clickInvitationLink: (e) ->
    $('.js-invitation-link').select()

  deactivateInvitationLink: (e) ->
    @$('.js-show-invitation-link').removeClass('hide')
    @$('.js-invitation-link-container').addClass('hide')
    @$('.js-invitation-link').val('')

    ApiPromise
      method: 'delete'
      url: @_secretUrl()
    .done()

  # EXPERIMENT: teamMembersTabLayoutV1
  copyInvitationLink: (e) ->
    $('.js-invitation-link').select()
    document.execCommand('copy')



// WEBPACK FOOTER //
// ./app/scripts/views/invitation-link/display-invitation-link-view.coffee